import { Card, Label, SectionHeader } from "@osago/ui";

export interface HowItWorksStep {
  title: string;
  text: string;
}

interface HowItWorksProps {
  steps: HowItWorksStep[];
}

/** Нумерованная памятка вверху конструктора: что сделать, чтобы получить результат. */
export function HowItWorks({ steps }: HowItWorksProps) {
  return (
    <Card padding="lg">
      <Label variant="section" as="h3" className="mb-3">
        Как это работает
      </Label>
      <div className="flex flex-col gap-3">
        {steps.map((step, index) => (
          <SectionHeader
            key={step.title}
            number={index + 1}
            title={step.title}
            subtitle={step.text}
          />
        ))}
      </div>
    </Card>
  );
}
